
export const actionTypes = {
  SET_DROPOFF_SERVICE_STATUS: "SET_DROPOFF_SERVICE_STATUS",
  SET_WELLNESS_SERVICE_STATUS: "SET_WELLNESS_SERVICE_STATUS",
  SET_INTEGRATED_SERVICE_STATUS: "SET_INTEGRATED_SERVICE_STATUS",
  SET_EXPRESS_SERVICE_STATUS: "SET_EXPRESS_SERVICE_STATUS",
  SET_ONLINE_PHARMACY_SERVICE_STATUS: "SET_ONLINE_PHARMACY_SERVICE_STATUS",
  SET_SERVICE_STORE_STATUS_UPDATED: "SET_SERVICE_STORE_STATUS_UPDATED",
  SET_IS_URGENT_CARE_ONLY: "SET_IS_URGENT_CARE_ONLY",
  RESET_SERVICE_STATUS_STORE: "RESET_SERVICE_STATUS_STORE",
};

const setDropoffServiceStatus = (payload: boolean) => ({
  type: actionTypes.SET_DROPOFF_SERVICE_STATUS,
  payload,
});

const setWellnessServiceStatus = (payload: boolean) => ({
  type: actionTypes.SET_WELLNESS_SERVICE_STATUS,
  payload,
});


const setIntegratedServiceStatus = (payload: boolean) => ({
  type: actionTypes.SET_INTEGRATED_SERVICE_STATUS,
  payload,
});

const setExpressServiceStatus = (payload: boolean) => ({
  type: actionTypes.SET_EXPRESS_SERVICE_STATUS,
  payload,
});

const setOnlinePharmacyServiceStatus = (payload: boolean) => ({
  type: actionTypes.SET_ONLINE_PHARMACY_SERVICE_STATUS,
  payload,
});

const setServiceStatusStoreUpdated = (payload: boolean) => ({
  type: actionTypes.SET_SERVICE_STORE_STATUS_UPDATED,
  payload,
});

const setIsUrgentCareOnly = (payload: boolean) => ({
  type: actionTypes.SET_IS_URGENT_CARE_ONLY,
  payload,
});

const resetServiceStatusStore = () => ({
  type: actionTypes.RESET_SERVICE_STATUS_STORE,
});


export default {
  setDropoffServiceStatus,
  setWellnessServiceStatus,
  setIntegratedServiceStatus,
  setExpressServiceStatus,
  setOnlinePharmacyServiceStatus,
  setServiceStatusStoreUpdated,
  setIsUrgentCareOnly,
  resetServiceStatusStore,
};
